import { Button } from "@mui/material";
import type { ButtonProps } from "@mui/material/Button";
import classNames from "classnames";
import { forwardRef } from "react";
import styles from "./styles.module.css";

interface Props extends ButtonProps {
  buttonType: "contained" | "outlined" | "text";
  icon?: JSX.Element | null;
  small?: boolean;
  warning?: boolean;
  disabled?: boolean;
}

export const AppButton = forwardRef<HTMLButtonElement, Props>(
  (
    {
      className,
      children,
      icon,
      buttonType,
      small,
      warning,
      disabled,
      ...props
    },
    ref
  ) => {
    return (
      <Button
        ref={ref}
        variant={buttonType}
        startIcon={icon}
        className={classNames(
          styles.button,
          styles[buttonType],
          {
            [styles.small]: small,
            [styles.warning]: warning,
            [styles.disabled]: disabled,
          },
          className
        )}
        classes={{
          icon: classNames(styles.icon),
        }}
        disabled={disabled}
        {...props}
      >
        {children}
      </Button>
    );
  }
);
